import { render } from "./HeaderOrderDocument.vue?vue&type=template&id=4127e29a&scoped=true"
import script from "./HeaderOrderDocument.vue?vue&type=script&lang=js"
export * from "./HeaderOrderDocument.vue?vue&type=script&lang=js"

import "./HeaderOrderDocument.vue?vue&type=style&index=0&id=4127e29a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4127e29a"]])

export default __exports__